import React from 'react';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const TabTen = ({ 
  timesheetData, 
  setTimesheetData,
  taskAssignmentData,
  setTaskAssignmentData,
  timeEntryData,
  setTimeEntryData,
  detailReport,
  setDetailReport,
  summarizedReport,
  setSummarizedReport,
  setTaskBasedReport,
  taskBasedReport,
  setVarianceReport,
  varianceReport,
  employeeTimesheetData,
  setEmployeeTimesheetData,
  onClickAll }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Activity Management
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="task-management-form-all"
            control={
              <Checkbox
                id="work-model-all"
                checked={timesheetData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(timesheetData, 'common', setTimesheetData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {timesheetData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={timesheetData[index]?.value}
                    onChange={(e) => {
                      let items = [...timesheetData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTimesheetData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Task Assignment
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="task-assignment-form-all"
            control={
              <Checkbox
                id="task-assignment-all"
                checked={taskAssignmentData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(
                    taskAssignmentData,
                    'common',
                    setTaskAssignmentData,
                    e
                  )
                }
              />
            }
            label="All"
          />
        </Grid>
        {taskAssignmentData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={taskAssignmentData[index]?.value}
                    onChange={(e) => {
                      let items = [...taskAssignmentData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTaskAssignmentData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Time Entry
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="time-entry-form-all"
            control={
              <Checkbox
                id="time-entry-all"
                checked={timeEntryData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(timeEntryData, 'common', setTimeEntryData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {timeEntryData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={timeEntryData[index]?.value}
                    onChange={(e) => {
                      let items = [...timeEntryData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTimeEntryData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employee Timesheet
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="employee-timesheet-form-all"
            control={
              <Checkbox
                id="employee-timesheet-all"
                checked={employeeTimesheetData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(
                    employeeTimesheetData,
                    'common',
                    setEmployeeTimesheetData,
                    e
                  )
                }
              />
            }
            label="All"
          />
        </Grid>
        {employeeTimesheetData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={employeeTimesheetData[index]?.value}
                    onChange={(e) => {
                      let items = [...employeeTimesheetData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setEmployeeTimesheetData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Reports
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="reports-form-all"
            control={
              <Checkbox
                id="reports-all"
                checked={
                  detailReport.every((dash) => dash.value) &&
                  summarizedReport.every((dash) => dash.value)&&
                  taskBasedReport.every((dash) => dash.value)&&
                  varianceReport.every((dash) => dash.value)
                }
                onClick={(e) => {
                  // Update both detailReport and summarizedReport
                  onClickAll(detailReport, 'common', setDetailReport, e);
                  onClickAll(summarizedReport,'common',setSummarizedReport,e);
                  onClickAll(taskBasedReport, 'common', setTaskBasedReport, e);
                  onClickAll(varianceReport, 'common', setVarianceReport, e);
                }}
              />
            }
            label="All"
          />
        </Grid>
        {detailReport.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={detailReport[index]?.value}
                    onChange={(e) => {
                      let items = [...detailReport];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setDetailReport(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
        {summarizedReport.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={summarizedReport[index]?.value}
                    onChange={(e) => {
                      let items = [...summarizedReport];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setSummarizedReport(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}

        {taskBasedReport.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={taskBasedReport[index]?.value}
                    onChange={(e) => {
                      let items = [...taskBasedReport];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setTaskBasedReport(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
        {varianceReport.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={varianceReport[index]?.value}
                    onChange={(e) => {
                      let items = [...varianceReport];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setVarianceReport(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default TabTen;
